module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/nudge/cart-nudge-bc1089cc0742e024e194c9f3c8a4ee12.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/nudge/cart-nudge.svg
// module id = mVnE
// module chunks = 24